import type { EventGuestAttendingWith, Paging } from "@anggunpraya-templates/types";

export const EVENT_GUEST_ATTENDING_WITH_OBJECT: Record<EventGuestAttendingWith, string> = {
  family: "Keluarga",
  alone: "Sendiri",
  partner: "Partner",
};

export const PAGING: Paging = {
  page: 1,
  limit: 20,
  count: 0,
  total: 0,
  next: false,
  prev: false,
};

export interface Ap006ImageSlide {
  src: string;
  alt: string;
  position: string;
};

export const AP_006_OPENING_SLIDES: Ap006ImageSlide[] = [
  {
    src: "/opening-card.webp",
    alt: "Foto pembuka Deva dan Rifqah",
    position: "object-[50%_44%]",
  },
  {
    src: "/hero.webp",
    alt: "Foto Deva dan Rifqah",
    position: "object-[48%_center]",
  },
  {
    src: "/opening-card-2.webp",
    alt: "Potret Deva dan Rifqah",
    position: "object-[50%_center]",
  },
];

export const AP_006_HERO_SLIDES: Ap006ImageSlide[] = AP_006_OPENING_SLIDES;
